import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const BackButton = () => {
  return (
    <Button variant="outline" onClick={() => history.back()}>
      <ArrowLeft className="w-5 h-5" />
      Back
    </Button>
  );
};
